import * as React from 'react';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import {
    personaCardBehavior,
    PersonaCardBehaviorProps,
} from 'owa-persona/lib/components/PersonaCardBehavior';
import { observer } from 'mobx-react';

const styles = require('./GroupFacepilePersona.scss');

@personaCardBehavior
@observer
export default class GroupFacepilePersona extends React.Component<
    PersonaCardBehaviorProps,
    React.ComponentState
> {
    render(): any {
        return (
            <div className={styles.groupFacepilePersona}>
                <PersonaControl
                    name={this.props.name}
                    emailAddress={this.props.emailAddress}
                    size={PersonaSize.size24}
                />
            </div>
        );
    }
}
